/*
 * Types.
 */

export enum PermissionDeniedReasonsEnum {
  ADMINISTRATOR_DISABLED = 'administrator_disabled',
  OFFLINE = 'offline',
  BULK_UNSUPPORTED = 'bulk_unsupported',
  MESSAGE_SENDING = 'message_sending',
  BULK_UNSUPPORTED_REFINEMENTS = 'bulk_unsupported_refinements',
}

interface PermissionResultBase {
  isAllowed: boolean;
}

interface AllowedPermissionResult extends PermissionResultBase {
  isAllowed: true;
}

interface DeniedPermissionResult extends PermissionResultBase {
  isAllowed: false;
  reason: PermissionDeniedReasonsEnum;
}

export type PermissionResult = AllowedPermissionResult | DeniedPermissionResult;

/*
 * Helpers.
 */

export function yesPermission(): AllowedPermissionResult {
  return {
    isAllowed: true,
  };
}

export function noPermission(reason: PermissionDeniedReasonsEnum): DeniedPermissionResult {
  return {
    isAllowed: false,
    reason,
  };
}

/** Returns the first denied permission, or an allowed permission if there are none. */
export function combinePermissions(
  firstPermissionResult: PermissionResult,
  ...restPermissionResults: ReadonlyArray<PermissionResult>
) {
  // We require at least one permission result.
  const permissionResults = [firstPermissionResult, ...restPermissionResults];
  const firstNoPermissionResult = permissionResults.find((permissionResult) => !permissionResult.isAllowed);
  return firstNoPermissionResult || yesPermission();
}
